@if (moneybarData) {
  <app-moneybar [moneybarData]="moneybarData"></app-moneybar>
  <app-moneybar-sidepanel [moneybarData]="moneybarData" [color]="color"></app-moneybar-sidepanel>
  <button
    mat-button
    *ngxPermissionsOnly="rolesToDownload"
    color="primary"
    class="o100w-moneybar-container-button"
    [ngClass]="'o100w-moneybar-container-button--' + color"
    (click)="downloadDonations()"
  >
    <i class="fa-solid fa-users"></i>
    <p class="o100w-moneybar-container-button-text">
      {{ moneybarData.uniqueDonors }}
    </p>
  </button>
  <button
    mat-button
    *ngxPermissionsOnly="rolesToDownload"
    color="primary"
    class="o100w-moneybar-container-button"
    [ngClass]="'o100w-moneybar-container-button--' + color"
    (click)="downloadDetails()"
  >
    <i class="fa-solid fa-laptop-arrow-down"></i>
    <p class="o100w-moneybar-container-button-text"></p>
  </button>
}
